import { render, staticRenderFns } from "./TabPrecificacaoValorEmpresa.vue?vue&type=template&id=78381cd6&"
import script from "./TabPrecificacaoValorEmpresa.vue?vue&type=script&lang=js&"
export * from "./TabPrecificacaoValorEmpresa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports